import { render } from "./App.vue?vue&type=template&id=b171b6ac"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=b171b6ac&lang=scss"
script.render = render

export default script